import Table from "../../../Components/Table/Table";
import SVG from "../../../Components/SVG";
import { toJalaliDateTime } from "../../../helper/toJalaliDateTime";
import TableLoading from "../../../Components/Loader/TableLoading";

const columns = [
  { key: "uuid", label: "کد معامله" },
  { key: "symbol", label: "نماد" },
  { key: "side", label: "ساید" },
  { key: "type", label: "نوع" },
  { key: "openTime", label: "زمان ورود" },
  { key: "openPrice", label: "قیمت ورود" },
  { key: "closeTime", label: "زمان خروج" },
  { key: "closePrice", label: "قیمت خروج" },
  { key: "volume", label: "حجم" },
  { key: "pnl", label: "سود" },
];

const orderTypeLabels = {
  limit: "لیمیت",
  market: "مارکت",
  stop_limit: "استاپ لیمیت",
  stop_market: "استاپ مارکت",
};

const formatPriceTrimmed = (value) => {
  const num = Number(value);
  return Number.isFinite(num)
    ? num.toLocaleString("en-US", { maximumFractionDigits: 18 })
    : "-";
};

const formatMoney = (value) => {
  const num = Number(value);
  return Number.isFinite(num)
    ? Number(num.toFixed(2)).toLocaleString()
    : "-";
};

const formatPnl = (value) => {
  const pnl = Number(value);
  return pnl >= 0
    ? `$${formatMoney(pnl)}`
    : `-$${formatMoney(Math.abs(pnl))}`;
};

export default function TradeHistoryTable({ accountData, accLoading }) {
  const trades = accountData?.trades ?? [];
  const data = trades.map((trade) => ({
    uuid: trade.id,
    symbol: trade.symbol?.toUpperCase?.() ?? "-",
    side: trade.side === "long" ? "لانگ" : trade.side === "short" ? "شورت" : "-",
    type: orderTypeLabels[trade.order_type] ?? "-",
    openTime: toJalaliDateTime(trade.opened_at),
    openPrice: `$${formatPriceTrimmed(trade.entry_price)}`,
    closeTime: toJalaliDateTime(trade.closed_at),
    closePrice: `$${formatPriceTrimmed(trade.exit_price)}`,
    volume: `$${formatMoney(trade.margin_usdt)}`,
    pnl: formatPnl(trade.profit_loss),
    detail: "",
  }));

  return (
    <div className="w-full h-fit flex flex-col gap-5 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark overflow-hidden min-h-0">
      <Table
        maxHeight={accLoading || data.length === 0 ? undefined : "calc(100dvh - 306px)"}
        haveScroll={!accLoading && data.length > 0}
        isLTR={true}
        columns={columns}
        data={accLoading ? [] : data}
      />

      {accLoading && (
        <div className="w-full flex justify-center items-center gap-2">
          <p className="text-[#808080]">در حال بارگذاری</p>
          <TableLoading className="text-[#808080]" />
        </div>
      )}

      {!accLoading && accountData?.trades && data.length === 0 && (
        <div className="w-full flex justify-center items-center flex-col gap-5">
          <p className="text-zi-text-light dark:text-zi-text-dark text-sm sm:text-base">
            موردی برای نمایش وجود ندارد
          </p>
          <SVG name="noData" classname="w-24 fill-cyan-500" />
        </div>
      )}
    </div>
  );
}
